var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43329 0.292002C2.53206 0.199198 2.64928 0.125642 2.77826 0.0755384C2.90723 0.025435 3.04542 -0.000233099 3.18493 1.59499e-06H18.0479C18.3295 1.59499e-06 18.5995 0.105358 18.7986 0.292895C18.9977 0.480431 19.1096 0.734785 19.1096 1C19.1096 2.36 18.3834 3.348 17.7379 3.958C17.4704 4.208 17.2071 4.406 16.9863 4.554V13.416L17.1519 13.512C17.5829 13.766 18.1626 14.14 18.7465 14.622C19.874 15.55 21.2329 17.054 21.2329 19C21.2329 19.2652 21.121 19.5196 20.9219 19.7071C20.7228 19.8946 20.4528 20 20.1712 20H11.6781V29C11.6781 29.552 11.2025 32 10.6164 32C10.0304 32 9.55479 29.552 9.55479 29V20H1.06164C0.780078 20 0.510045 19.8946 0.310948 19.7071C0.111852 19.5196 0 19.2652 0 19C0 17.054 1.3589 15.55 2.48425 14.622C3.03354 14.1727 3.6232 13.7692 4.24658 13.416V4.554C3.97882 4.37543 3.72739 4.17607 3.49493 3.958C2.84945 3.348 2.12329 2.358 2.12329 1C2.12304 0.868592 2.15029 0.738424 2.20348 0.61694C2.25667 0.495457 2.33476 0.38504 2.43329 0.292002Z",
    fill: "#EDD9A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2fb67ff7ca00b33837e26167ba33b4af.svg";
export { ForwardRef as ReactComponent };